export default "__VITE_ASSET__SRb4wFtP__"